<div class="cellcoin-account-page">
  <header class="cellcoin-account-topbar">
    <div class="cellcoin-account-brand-row">
      <div class="cellcoin-account-logo">{{iniciaisDetalhesContaCellcoin()}}</div>
      <div>
        <div class="cellcoin-account-eyebrow">
          <span class="cellcoin-account-badge" [ngClass]="classeStatusDetalhesContaCellcoin()">
            <span class="cellcoin-account-dot"></span>
            {{rotuloStatusDetalhesContaCellcoin()}}
          </span>
          <span>Cellcoin Pay</span>
          <span>•</span>
          <span>{{carregando && !detalhesContaCellcoin ? 'Consultando dados' : 'Dados consultados'}}</span>
        </div>
        <h2>Detalhes da conta MeuCardapio Pay</h2>
        <div class="cellcoin-account-endpoint">{{tipoDetalhesContaCellcoin()}} </div>
      </div>
    </div>

    <div class="cellcoin-account-actions-top">
      <button type="button"
              class="cellcoin-account-btn cellcoin-account-btn-ghost"
              *ngIf="isAdmin"
              [disabled]="carregandoOpcoesWebhooksContaCellcoin"
              (click)="abraWebhooksContaCellcoin()">
        <i class="fas fa-exchange-alt"></i>
        Ver webhooks
      </button>
      <button type="button"
              class="cellcoin-account-btn"
              (click)="volteParaFormasPagamento()">
        <i class="fas fa-arrow-left"></i>
        Formas de pagamento
      </button>
      <button type="button"
              class="cellcoin-account-btn cellcoin-account-btn-ghost"
              [disabled]="carregando || !!executandoAcao || !podeVisualizarConta"
              (click)="carregueDetalhes()">
        <span class="spinner-border spinner-border-sm" *ngIf="carregando"></span>
        <i class="fas fa-sync-alt" *ngIf="!carregando"></i>
        Atualizar dados
      </button>
    </div>
  </header>

  <main class="cellcoin-account-body">
    <div class="alert alert-danger" *ngIf="erro">{{erro}}</div>
    <div class="alert alert-success" *ngIf="mensagem">{{mensagem}}</div>
    <div class="alert alert-warning" *ngIf="detalhesContaCellcoin?.saldoErro">
      Não foi possível consultar o saldo da conta: {{detalhesContaCellcoin.saldoErro}}
    </div>

    <div class="cellcoin-account-loading" *ngIf="carregando && !detalhesContaCellcoin">
      <div class="cellcoin-account-loading-card">
        <div class="cellcoin-account-loading-icon">
          <span class="spinner-border spinner-border-sm"></span>
        </div>
        <div>
          <strong>Consultando conta na Cellcoin</strong>
          <span>Buscando dados cadastrais, status e saldo disponível.</span>
        </div>
      </div>
      <div class="cellcoin-account-skeleton-grid">
        <div class="cellcoin-account-skeleton"></div>
        <div class="cellcoin-account-skeleton"></div>
        <div class="cellcoin-account-skeleton cellcoin-account-skeleton-wide"></div>
      </div>
    </div>

    <ng-container *ngIf="detalhesContaCellcoin">
      <section class="cellcoin-account-hero-grid">
        <div class="cellcoin-account-card">
          <div class="cellcoin-account-card-head">
            <div class="cellcoin-account-section-title">
              <i class="far fa-credit-card"></i>
              Resumo financeiro e bancário
            </div>
            <span class="cellcoin-account-badge" [ngClass]="classeStatusDetalhesContaCellcoin()">
              {{rotuloStatusDetalhesContaCellcoin()}}
            </span>
          </div>

          <div class="cellcoin-account-metrics">
            <article class="cellcoin-account-metric">
              <div class="cellcoin-account-label">Status</div>
              <div class="cellcoin-account-value">{{statusDetalhesContaCellcoin()}}</div>
              <div class="cellcoin-account-hint">{{mensagemStatusDetalhesContaCellcoin()}}</div>
            </article>
            <article class="cellcoin-account-metric">
              <div class="cellcoin-account-label">Conta</div>
              <div class="cellcoin-account-value">{{contaDetalhesContaCellcoin()}}</div>
              <div class="cellcoin-account-hint">Conta Cellcoin</div>
            </article>
            <article class="cellcoin-account-metric">
              <div class="cellcoin-account-label">Agência</div>
              <div class="cellcoin-account-value">{{agenciaDetalhesContaCellcoin()}}</div>
              <div class="cellcoin-account-hint">Cellcoin Pay</div>
            </article>
            <article class="cellcoin-account-metric">
              <div class="cellcoin-account-label">Documento</div>
              <div class="cellcoin-account-value">{{documentoDetalhesContaCellcoin()}}</div>
              <div class="cellcoin-account-hint">{{tipoDetalhesContaCellcoin()}} validado</div>
            </article>
            <article class="cellcoin-account-metric cellcoin-account-pix-key">
              <div class="cellcoin-account-label">Chave Pix EVP</div>
              <div class="cellcoin-account-value">{{chavePixDetalhesContaCellcoin()}}</div>
              <div class="cellcoin-account-hint">Chave registrada para recebimentos Pix</div>
            </article>
            <article class="cellcoin-account-metric cellcoin-account-balance">
              <div class="cellcoin-account-balance-primary">
                <div>
                  <div class="cellcoin-account-label">Disponível para transferir</div>
                  <div class="cellcoin-account-value">{{formateMoedaCellcoin(saldoTransferivelDetalhesContaCellcoin())}}</div>
                </div>
                <button type="button"
                        class="cellcoin-account-transfer-button"
                        *ngIf="podeTransferirSaldo"
                        [disabled]="saldoTransferivelDetalhesContaCellcoin() <= 0 || modalConfirmacaoTransferenciaCellcoin"
                        (click)="abraFluxoTransferenciaPixCellcoin()">
                  <i class="fas fa-paper-plane"></i>
                  Transferir
                </button>
              </div>
              <div class="cellcoin-account-balance-details"
                   *ngIf="possuiDetalhamentoSaldoCellcoin() || possuiResumoSaldoTransferenciaPixCellcoin()">
                <span *ngIf="possuiResumoSaldoTransferenciaPixCellcoin()">
                  Saldo Cellcoin
                  <strong>{{formateMoedaCellcoin(saldoDetalhesContaCellcoin())}}</strong>
                </span>
                <span *ngIf="saldoReservadoTransferenciasPixCellcoin() > 0">
                  Aguardando confirmação Pix
                  <strong>{{formateMoedaCellcoin(saldoReservadoTransferenciasPixCellcoin())}}</strong>
                </span>
                <span *ngIf="possuiDetalhamentoSaldoCellcoin()">
                  Saldo bloqueado
                  <strong>{{formateMoedaCellcoin(saldoBloqueadoDetalhesContaCellcoin())}}</strong>
                </span>
                <span *ngIf="possuiDetalhamentoSaldoCellcoin()">
                  Saldo total
                  <strong>{{formateMoedaCellcoin(saldoTotalDetalhesContaCellcoin())}}</strong>
                </span>
              </div>
              <div class="cellcoin-account-hint" *ngIf="detalhesContaCellcoin?.pixCashOut?.erro">
                Não foi possível calcular o saldo disponível para transferência.
              </div>
              <div class="cellcoin-account-hint" *ngIf="!detalhesContaCellcoin?.pixCashOut?.erro">
                {{saldoTotalDetalhesContaCellcoin() > 0 ? 'Zere o saldo antes de encerrar a conta' : 'Conta sem saldo disponível'}}
              </div>
            </article>
          </div>
        </div>

        <aside class="cellcoin-account-profile-card">
          <div class="cellcoin-account-profile-main">
            <div class="cellcoin-account-avatar">{{iniciaisDetalhesContaCellcoin()}}</div>
            <div>
              <h3>{{nomeDetalhesContaCellcoin()}}</h3>
              <p>{{tipoDetalhesContaCellcoin()}} • Código interno <strong>{{clientCodeDetalhesContaCellcoin()}}</strong></p>
            </div>
          </div>

          <div class="cellcoin-account-mini-info">
            <div class="cellcoin-account-mini">
              <span>E-mail</span>
              <strong>{{emailDetalhesContaCellcoin()}}</strong>
            </div>
            <div class="cellcoin-account-mini">
              <span>Telefone</span>
              <strong>{{telefoneDetalhesContaCellcoin()}}</strong>
            </div>
            <div class="cellcoin-account-mini">
              <span>Criada em</span>
              <strong>{{dataCriacaoDetalhesContaCellcoin()}}</strong>
            </div>
            <div class="cellcoin-account-mini">
              <span>Consulta</span>
              <strong>{{tipoDetalhesContaCellcoin()}}</strong>
            </div>
          </div>
        </aside>
      </section>

      <nav class="cellcoin-account-tabs" aria-label="Seções da conta">
        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'visao'"
                (click)="selecioneAba('visao')">Visão geral</button>

        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'extrato'"
                (click)="selecioneAba('extrato')">Extrato</button>
        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'consolidado'"
                (click)="selecioneAba('consolidado')">Consolidado</button>

        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'clientes'"
                (click)="selecioneAba('clientes')">Clientes</button>
        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'transferencias'"
                (click)="selecioneAba('transferencias')">Transferências Pix</button>
        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'cobrancas'"
                (click)="selecioneAba('cobrancas')">Cobranças</button>

        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'recorrencias'"
                (click)="selecioneAba('recorrencias')">Recorrências</button>

        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'recebiveis'"
                (click)="selecioneAba('recebiveis')">Recebíveis</button>

        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'chargebacks'"
                (click)="selecioneAba('chargebacks')">Chargebacks</button>


        <button class="cellcoin-account-tab"
                type="button"
                [class.active]="aba === 'auditoria'"
                (click)="selecioneAba('auditoria')">Auditoria</button>
      </nav>

      <section *ngIf="aba === 'visao'" class="cellcoin-account-tab-panel">
        <div class="cellcoin-account-content-grid">
          <div>
            <article class="cellcoin-account-panel">
              <div class="cellcoin-account-panel-header">
                <div class="cellcoin-account-section-title">Cadastro</div>
                <span class="cellcoin-account-badge cellcoin-account-badge-success">Dados verificados</span>
              </div>
              <div class="cellcoin-account-panel-body">
                <div class="cellcoin-account-data-grid">
                  <div class="cellcoin-account-field">
                    <div class="cellcoin-account-field-label"><i class="far fa-id-card"></i> Nome/Razão social</div>
                    <div class="cellcoin-account-field-value">{{bodyDetalhesContaCellcoin().businessName || bodyDetalhesContaCellcoin().fullName || '-'}}</div>
                  </div>
                  <div class="cellcoin-account-field">
                    <div class="cellcoin-account-field-label"><i class="far fa-building"></i> Nome fantasia/social</div>
                    <div class="cellcoin-account-field-value">{{bodyDetalhesContaCellcoin().tradingName || bodyDetalhesContaCellcoin().socialName || '-'}}</div>
                  </div>
                  <div class="cellcoin-account-field">
                    <div class="cellcoin-account-field-label"><i class="far fa-envelope"></i> E-mail</div>
                    <div class="cellcoin-account-field-value">{{emailDetalhesContaCellcoin()}}</div>
                  </div>
                  <div class="cellcoin-account-field">
                    <div class="cellcoin-account-field-label"><i class="fas fa-phone-alt"></i> Telefone</div>
                    <div class="cellcoin-account-field-value">{{telefoneDetalhesContaCellcoin()}}</div>
                  </div>
                  <div class="cellcoin-account-field">
                    <div class="cellcoin-account-field-label"><i class="fas fa-fingerprint"></i> Client code</div>
                    <div class="cellcoin-account-field-value">{{clientCodeDetalhesContaCellcoin()}}</div>
                  </div>
                  <div class="cellcoin-account-field">
                    <div class="cellcoin-account-field-label"><i class="far fa-calendar-alt"></i> Criada em</div>
                    <div class="cellcoin-account-field-value">{{dataCriacaoDetalhesContaCellcoin()}}</div>
                  </div>
                </div>
              </div>
            </article>

            <article class="cellcoin-account-panel" *ngIf="enderecoDetalhesContaCellcoin()">
              <div class="cellcoin-account-panel-header">
                <div class="cellcoin-account-section-title">Endereço</div>
              </div>
              <div class="cellcoin-account-panel-body">
                <div class="cellcoin-account-address-box">
                  <div class="cellcoin-account-map-pin"><i class="fas fa-map-marker-alt"></i></div>
                  <p>
                    {{enderecoDetalhesContaCellcoin().street}}, {{enderecoDetalhesContaCellcoin().number}}
                    <span *ngIf="enderecoDetalhesContaCellcoin().addressComplement"> - {{enderecoDetalhesContaCellcoin().addressComplement}}</span>
                    · {{enderecoDetalhesContaCellcoin().neighborhood}}
                    · {{enderecoDetalhesContaCellcoin().city}}/{{enderecoDetalhesContaCellcoin().state}}
                    · CEP {{enderecoDetalhesContaCellcoin().postalCode}}
                  </p>
                </div>
              </div>
            </article>

            <article class="cellcoin-account-panel" *ngIf="sociosDetalhesContaCellcoin().length">
              <div class="cellcoin-account-panel-header">
                <div class="cellcoin-account-section-title">Sócios/Responsáveis</div>
                <span class="cellcoin-account-badge cellcoin-account-badge-success">{{sociosDetalhesContaCellcoin().length}} responsável(is)</span>
              </div>
              <div class="cellcoin-account-panel-body">
                <div class="cellcoin-account-person" *ngFor="let socio of sociosDetalhesContaCellcoin()">
                  <div class="cellcoin-account-person-avatar">{{iniciaisPessoaCellcoin(socio.fullName)}}</div>
                  <div>
                    <h4>{{socio.fullName || '-'}}</h4>
                    <p><i class="far fa-id-card"></i> {{socio.documentNumber || '-'}}</p>
                    <p><i class="far fa-envelope"></i> {{socio.email || '-'}}</p>
                    <p><i class="fas fa-phone-alt"></i> {{socio.phoneNumber || '-'}}</p>
                    <p *ngIf="socio.motherName"><i class="far fa-user"></i> Mãe: {{socio.motherName}}</p>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <aside>
            <article class="cellcoin-account-side-card">
              <div class="cellcoin-account-section-title">Checklist operacional</div>
              <div class="cellcoin-account-status-list">
                <div class="cellcoin-account-status-item">
                  <span>Status da conta</span>
                  <strong>{{statusDetalhesContaCellcoin()}}</strong>
                </div>
                <div class="cellcoin-account-status-item">
                  <span>Saldo</span>
                  <strong>{{formateMoedaCellcoin(saldoDetalhesContaCellcoin())}}</strong>
                </div>
                <div class="cellcoin-account-status-item">
                  <span>Documento</span>
                  <strong>{{documentoDetalhesContaCellcoin()}}</strong>
                </div>
                <div class="cellcoin-account-status-item">
                  <span>Tipo</span>
                  <strong>{{tipoDetalhesContaCellcoin()}}</strong>
                </div>
              </div>
            </article>

            <article class="cellcoin-account-side-card cellcoin-account-risk-card">
              <div class="cellcoin-account-section-title">Atenção</div>
              <p *ngIf="saldoDetalhesContaCellcoin() > 0">
                Esta conta possui saldo disponível. Para encerrar a conta, zere o saldo primeiro.
              </p>
              <p *ngIf="!saldoDetalhesContaCellcoin() && detalhesContaCellcoin?.saldoErro">
                A consulta de saldo retornou erro. Valide o saldo antes de encerrar a conta.
              </p>
              <p *ngIf="!saldoDetalhesContaCellcoin() && !detalhesContaCellcoin?.saldoErro">
                Nenhuma pendência crítica retornada nesta consulta.
              </p>
            </article>

            <article class="cellcoin-account-actions-card" *ngIf="isAdmin">
              <div class="cellcoin-account-section-title">Ações da conta</div>
              <button kendoButton
                      themeColor="primary"
                      *ngIf="contaPodeSerAtivada()"
                      [disabled]="!!executandoAcao || carregando || !detalhesContaCellcoin"
                      (click)="desativeContaCellcoin()">
                <span class="spinner-border spinner-border-sm mr-1" *ngIf="acaoContaCellcoinEmExecucao('ativar')"></span>
                Ativar conta
              </button>
              <button kendoButton
                      *ngIf="!contaPodeSerAtivada()"
                      [disabled]="!!executandoAcao || carregando || !detalhesContaCellcoin"
                      (click)="desativeContaCellcoin()">
                <span class="spinner-border spinner-border-sm mr-1" *ngIf="acaoContaCellcoinEmExecucao(contaPodeSerAtivada() ? 'ativar' : 'desativar')"></span>
                {{textoBotaoAtivarDesativarConta()}}
              </button>
              <button kendoButton
                      themeColor="error"
                      [disabled]="!!executandoAcao || carregando || !detalhesContaCellcoin"
                      (click)="encerreContaCellcoin()">
                <span class="spinner-border spinner-border-sm mr-1" *ngIf="acaoContaCellcoinEmExecucao('encerrar')"></span>
                Encerrar conta
              </button>
            </article>
          </aside>
        </div>
      </section>

      <section *ngIf="aba === 'transferencias'" class="cellcoin-account-tab-panel">
        <article class="cellcoin-account-panel">
          <div class="cellcoin-account-panel-header cellcoin-transfer-header">
            <div>
              <div class="cellcoin-account-section-title">
                <i class="fas fa-history"></i> Histórico de transferências Pix
              </div>
              <span>Transferências enviadas, confirmações, rejeições e devoluções recebidas pela Cellcoin.</span>
            </div>
            <span class="cellcoin-account-badge">
              {{transferenciasCellcoin.length}} registro(s) nesta página
            </span>
          </div>

          <div class="cellcoin-account-panel-body">
            <div class="cellcoin-statement-error" *ngIf="erroTransferenciasCellcoin">
              <i class="fas fa-exclamation-circle"></i>
              <span>{{erroTransferenciasCellcoin}}</span>
            </div>

            <div class="alert alert-info" *ngIf="mensagemTransferenciasCellcoin">
              {{mensagemTransferenciasCellcoin}}
            </div>

            <div class="cellcoin-transfer-history-head">
              <div>
                <strong>Movimentações realizadas</strong>
                <span>Preparações canceladas ou expiradas não aparecem neste histórico.</span>
              </div>
              <button type="button"
                      class="cellcoin-account-btn cellcoin-account-btn-ghost"
                      [disabled]="carregandoTransferenciasCellcoin"
                      (click)="carregueTransferenciasCellcoin(paginaTransferenciasCellcoin)">
                <span class="spinner-border spinner-border-sm" *ngIf="carregandoTransferenciasCellcoin"></span>
                <i class="fas fa-sync-alt" *ngIf="!carregandoTransferenciasCellcoin"></i>
                Atualizar
              </button>
            </div>

            <div class="cellcoin-statement-loading" *ngIf="carregandoTransferenciasCellcoin">
              <span class="spinner-border spinner-border-sm"></span>
              Consultando transferências Pix...
            </div>

            <div class="cellcoin-statement-empty"
                 *ngIf="!carregandoTransferenciasCellcoin && !transferenciasCellcoin.length && !erroTransferenciasCellcoin">
              <i class="far fa-folder-open"></i>
              <strong>Nenhuma transferência realizada</strong>
              <span>As transferências desta conta aparecerão aqui.</span>
            </div>

            <div class="cellcoin-statement-table-wrap"
                 *ngIf="!carregandoTransferenciasCellcoin && transferenciasCellcoin.length">
              <table class="cellcoin-statement-table cellcoin-transfer-table">
                <thead>
                <tr>
                  <th>Data</th>
                  <th>Destinatário</th>
                  <th>Status</th>
                  <th>Identificador</th>
                  <th class="cellcoin-statement-number">Valor</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let transferencia of transferenciasCellcoin">
                  <td>{{formateDataTransferenciaCellcoin(transferencia.preparadaEm)}}</td>
                  <td>
                    <strong>{{transferencia.destinatario?.nome || '-'}}</strong>
                    <span>{{transferencia.destinatario?.tipoChave}} · {{transferencia.destinatario?.chave}}</span>
                  </td>
                  <td>
                    <span class="cellcoin-transfer-status"
                          [ngClass]="classeStatusTransferenciaCellcoin(transferencia.status)">
                      {{rotuloStatusTransferenciaCellcoin(transferencia.status)}}
                    </span>
                    <small *ngIf="transferencia.erro?.mensagem">{{transferencia.erro.mensagem}}</small>
                  </td>
                  <td class="cellcoin-statement-reference">
                    {{transferencia.transactionId || transferencia.endToEndId || transferencia.clientCode}}
                  </td>
                  <td class="cellcoin-statement-number">
                    <strong>{{formateMoedaCellcoin(transferencia.valor)}}</strong>
                  </td>
                  <td class="cellcoin-transfer-action">
                    <button type="button"
                            class="cellcoin-account-btn cellcoin-account-btn-ghost"
                            *ngIf="!transferenciaTerminalCellcoin(transferencia) && transferencia.status !== 'PREPARED'"
                            [disabled]="transferenciaConsultandoStatusCellcoin != null"
                            (click)="consulteStatusTransferenciaPixCellcoin(transferencia)">
                      <span class="spinner-border spinner-border-sm"
                            *ngIf="transferenciaConsultandoStatus(transferencia)"></span>
                      Verificar status
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="cellcoin-statement-pagination"
                 *ngIf="!carregandoTransferenciasCellcoin && transferenciasCellcoin.length">
              <span>Página {{paginaTransferenciasCellcoin}}</span>
              <div>
                <button type="button" class="cellcoin-account-btn" title="Página anterior"
                        [disabled]="paginaTransferenciasCellcoin <= 1"
                        (click)="paginaAnteriorTransferenciasCellcoin()">
                  <i class="fas fa-chevron-left"></i>
                </button>
                <button type="button" class="cellcoin-account-btn" title="Próxima página"
                        [disabled]="!possuiProximaPaginaTransferenciasCellcoin"
                        (click)="proximaPaginaTransferenciasCellcoin()">
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>
      </section>

      <section *ngIf="aba === 'extrato'" class="cellcoin-account-tab-panel">
        <article class="cellcoin-account-panel">
          <div class="cellcoin-account-panel-header cellcoin-statement-header">
            <div>
              <div class="cellcoin-account-section-title"><i class="fas fa-list-alt"></i> Extrato detalhado</div>
              <span>Movimentações da conta Cellcoin em períodos de até 7 dias.</span>
            </div>
            <span class="cellcoin-account-badge cellcoin-account-badge-success" *ngIf="!carregandoExtratoCellcoin && extratoCellcoin">
              {{totalItensExtratoCellcoin}} registro(s)
            </span>
          </div>
          <div class="cellcoin-account-panel-body">
            <form class="cellcoin-statement-filters" (ngSubmit)="carregueExtratoCellcoin(1)">
              <label>
                <span>Data inicial</span>
                <input class="k-textbox" type="date" name="dataInicialExtratoCellcoin"
                       [(ngModel)]="dataInicialExtratoCellcoin" [disabled]="carregandoExtratoCellcoin">
              </label>
              <label>
                <span>Data final</span>
                <input class="k-textbox" type="date" name="dataFinalExtratoCellcoin"
                       [(ngModel)]="dataFinalExtratoCellcoin" [disabled]="carregandoExtratoCellcoin">
              </label>
              <label class="cellcoin-statement-type-filter">
                <span>Tipo de movimentação</span>
                <select class="k-textbox" name="tipoMovimentoExtratoCellcoin"
                        [(ngModel)]="tipoMovimentoExtratoCellcoin" [disabled]="carregandoExtratoCellcoin">
                  <option *ngFor="let tipo of tiposMovimentoExtratoCellcoin" [value]="tipo.valor">{{tipo.rotulo}}</option>
                </select>
              </label>
              <button kendoButton themeColor="primary" type="submit" [disabled]="carregandoExtratoCellcoin">
                <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoExtratoCellcoin"></span>
                Consultar
              </button>
            </form>

            <div class="cellcoin-statement-error" *ngIf="erroExtratoCellcoin">
              <i class="fas fa-exclamation-circle"></i>
              <span>{{erroExtratoCellcoin}}</span>
            </div>

            <div class="cellcoin-statement-loading" *ngIf="carregandoExtratoCellcoin">
              <span class="spinner-border spinner-border-sm"></span>
              Consultando extrato na Cellcoin...
            </div>

            <div class="cellcoin-statement-empty"
                 *ngIf="!carregandoExtratoCellcoin && extratoCellcoin && !movimentosExtratoCellcoin.length && !erroExtratoCellcoin">
              <i class="far fa-folder-open"></i>
              <strong>Nenhuma movimentação encontrada</strong>
              <span>Altere o período ou o tipo de movimentação para realizar outra consulta.</span>
            </div>

            <div class="cellcoin-statement-table-wrap" *ngIf="!carregandoExtratoCellcoin && movimentosExtratoCellcoin.length">
              <table class="cellcoin-statement-table">
                <thead>
                <tr>
                  <th>Data</th>
                  <th>Movimento</th>
                  <th>Identificador</th>
                  <th>Natureza</th>
                  <th class="cellcoin-statement-number">Valor</th>
                  <th class="cellcoin-statement-number">Saldo</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let movimento of movimentosExtratoCellcoin">
                  <td>{{formateDataMovimentoCellcoin(movimento.createDate)}}</td>
                  <td>
                    <strong>{{rotuloTipoMovimentoCellcoin(movimento.movementType)}}</strong>
                    <span *ngIf="movimento.description">{{movimento.description}}</span>
                  </td>
                  <td class="cellcoin-statement-reference">{{identificadorMovimentoCellcoin(movimento)}}</td>
                  <td>
                    <span class="cellcoin-statement-nature"
                          [class.cellcoin-statement-credit]="movimentoEhCreditoCellcoin(movimento)"
                          [class.cellcoin-statement-debit]="!movimentoEhCreditoCellcoin(movimento)">
                      {{movimentoEhCreditoCellcoin(movimento) ? 'Crédito' : 'Débito'}}
                    </span>
                  </td>
                  <td class="cellcoin-statement-number cellcoin-statement-amount"
                      [class.cellcoin-statement-credit-text]="movimentoEhCreditoCellcoin(movimento)"
                      [class.cellcoin-statement-debit-text]="!movimentoEhCreditoCellcoin(movimento)">
                    {{movimentoEhCreditoCellcoin(movimento) ? '+' : '-'}} {{formateMoedaCellcoin(valorMovimentoCellcoin(movimento))}}
                  </td>
                  <td class="cellcoin-statement-number">
                    {{saldoMovimentoCellcoin(movimento) == null ? '-' : formateMoedaCellcoin(saldoMovimentoCellcoin(movimento))}}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="cellcoin-statement-pagination" *ngIf="!carregandoExtratoCellcoin && totalPaginasExtratoCellcoin > 0">
              <span>Página {{paginaExtratoCellcoin}} de {{totalPaginasExtratoCellcoin}}</span>
              <div>
                <button type="button" class="cellcoin-account-btn" title="Página anterior"
                        [disabled]="paginaExtratoCellcoin <= 1" (click)="paginaAnteriorExtratoCellcoin()">
                  <i class="fas fa-chevron-left"></i>
                </button>
                <button type="button" class="cellcoin-account-btn" title="Próxima página"
                        [disabled]="paginaExtratoCellcoin >= totalPaginasExtratoCellcoin" (click)="proximaPaginaExtratoCellcoin()">
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>
      </section>

      <section *ngIf="aba === 'consolidado'" class="cellcoin-account-tab-panel">
        <article class="cellcoin-account-panel">
          <div class="cellcoin-account-panel-header cellcoin-statement-header">
            <div>
              <div class="cellcoin-account-section-title"><i class="fas fa-balance-scale"></i> Movimentações consolidadas</div>
              <span>Resumo diário de créditos, débitos e tipos de movimentação em períodos de até 7 dias.</span>
            </div>
            <span class="cellcoin-account-badge cellcoin-account-badge-success"
                  *ngIf="!carregandoConsolidadoCellcoin && consolidadoCellcoin">
              {{saldosConsolidadosCellcoin.length}} dia(s)
            </span>
          </div>
          <div class="cellcoin-account-panel-body">
            <form class="cellcoin-statement-filters cellcoin-consolidated-filters"
                  (ngSubmit)="carregueConsolidadoCellcoin()">
              <label>
                <span>Data inicial</span>
                <input class="k-textbox" type="date" name="dataInicialConsolidadoCellcoin"
                       [(ngModel)]="dataInicialConsolidadoCellcoin" [disabled]="carregandoConsolidadoCellcoin">
              </label>
              <label>
                <span>Data final</span>
                <input class="k-textbox" type="date" name="dataFinalConsolidadoCellcoin"
                       [(ngModel)]="dataFinalConsolidadoCellcoin" [disabled]="carregandoConsolidadoCellcoin">
              </label>
              <button kendoButton themeColor="primary" type="submit" [disabled]="carregandoConsolidadoCellcoin">
                <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoConsolidadoCellcoin"></span>
                Consultar
              </button>
            </form>

            <div class="cellcoin-statement-error" *ngIf="erroConsolidadoCellcoin">
              <i class="fas fa-exclamation-circle"></i>
              <span>{{erroConsolidadoCellcoin}}</span>
            </div>

            <div class="cellcoin-statement-loading" *ngIf="carregandoConsolidadoCellcoin">
              <span class="spinner-border spinner-border-sm"></span>
              Consultando movimentações consolidadas na Cellcoin...
            </div>

            <ng-container *ngIf="!carregandoConsolidadoCellcoin && consolidadoCellcoin">
              <div class="cellcoin-consolidated-summary">
                <div>
                  <span>Saldo atual</span>
                  <strong>{{formateMoedaCellcoin(saldoAtualConsolidadoCellcoin())}}</strong>
                </div>
                <div>
                  <span>Créditos no período</span>
                  <strong class="cellcoin-statement-credit-text">+ {{formateMoedaCellcoin(totalCreditosConsolidadoCellcoin())}}</strong>
                </div>
                <div>
                  <span>Débitos no período</span>
                  <strong class="cellcoin-statement-debit-text">- {{formateMoedaCellcoin(totalDebitosConsolidadoCellcoin())}}</strong>
                </div>
                <div>
                  <span>Resultado do período</span>
                  <strong [class.cellcoin-statement-credit-text]="resultadoConsolidadoCellcoin() >= 0"
                          [class.cellcoin-statement-debit-text]="resultadoConsolidadoCellcoin() < 0">
                    {{resultadoConsolidadoCellcoin() >= 0 ? '+' : '-'}}
                    {{formateMoedaCellcoin(resultadoConsolidadoCellcoin() < 0 ? -resultadoConsolidadoCellcoin() : resultadoConsolidadoCellcoin())}}
                  </strong>
                </div>
              </div>

              <div class="cellcoin-statement-empty"
                   *ngIf="!saldosConsolidadosCellcoin.length && !erroConsolidadoCellcoin">
                <i class="far fa-folder-open"></i>
                <strong>Nenhuma movimentação consolidada encontrada</strong>
                <span>Altere o período para realizar outra consulta.</span>
              </div>

              <div class="cellcoin-statement-table-wrap" *ngIf="saldosConsolidadosCellcoin.length">
                <table class="cellcoin-statement-table cellcoin-consolidated-table">
                  <thead>
                  <tr>
                    <th>Data</th>
                    <th class="cellcoin-statement-number">Saldo inicial</th>
                    <th class="cellcoin-statement-number">Créditos</th>
                    <th class="cellcoin-statement-number">Débitos</th>
                    <th class="cellcoin-statement-number">Saldo final</th>
                    <th>Composição</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let saldo of saldosConsolidadosCellcoin">
                    <td>
                      <strong>{{formateDataConsolidadoCellcoin(saldo.date)}}</strong>
                      <span>{{saldo.qtdMovement || 0}} movimentação(ões)</span>
                    </td>
                    <td class="cellcoin-statement-number">
                      {{formateMoedaCellcoin(saldoInicialDiaConsolidadoCellcoin(saldo))}}
                    </td>
                    <td class="cellcoin-statement-number cellcoin-statement-credit-text">
                      + {{formateMoedaCellcoin(saldo.totalMovementCredit)}}
                    </td>
                    <td class="cellcoin-statement-number cellcoin-statement-debit-text">
                      - {{formateMoedaCellcoin(saldo.totalMovementDebit < 0 ? -saldo.totalMovementDebit : saldo.totalMovementDebit)}}
                    </td>
                    <td class="cellcoin-statement-number">
                      <strong>{{formateMoedaCellcoin(saldoFinalDiaConsolidadoCellcoin(saldo))}}</strong>
                    </td>
                    <td>
                      <div class="cellcoin-consolidated-movements" *ngIf="movimentosDiaConsolidadoCellcoin(saldo).length">
                        <div *ngFor="let movimento of movimentosDiaConsolidadoCellcoin(saldo)">
                          <span>
                            {{movimento.movementDescription || rotuloTipoMovimentoCellcoin(movimento.movementType)}}
                            <small>{{movimento.movementType}} · {{movimento.qtdMovement || 0}}x</small>
                          </span>
                          <strong [class.cellcoin-statement-credit-text]="movimentoConsolidadoEhCreditoCellcoin(movimento)"
                                  [class.cellcoin-statement-debit-text]="!movimentoConsolidadoEhCreditoCellcoin(movimento)">
                            {{movimentoConsolidadoEhCreditoCellcoin(movimento) ? '+' : '-'}}
                            {{formateMoedaCellcoin(valorMovimentoConsolidadoCellcoin(movimento))}}
                          </strong>
                        </div>
                      </div>
                      <span *ngIf="!movimentosDiaConsolidadoCellcoin(saldo).length">Sem composição retornada</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </div>
        </article>
      </section>

      <section *ngIf="aba === 'recebiveis'" class="cellcoin-account-tab-panel">
        <article class="cellcoin-account-panel">
          <div class="cellcoin-account-panel-header cellcoin-statement-header">
            <div>
              <div class="cellcoin-account-section-title">
                <i class="fas fa-calendar-check"></i> Recebíveis de cartão
              </div>
              <span>Valores capturados, suas taxas e as datas previstas ou efetivas de liquidação.</span>
            </div>
          </div>

          <div class="cellcoin-account-panel-body">
            <div class="cellcoin-receivables-history">
              <label>
                <span>Relatórios disponíveis</span>
                <select class="k-textbox"
                        [(ngModel)]="requestIdRecebiveisSelecionadoCellcoin"
                        [disabled]="carregandoRecebiveisCellcoin || !solicitacoesRecebiveisCellcoin.length"
                        (ngModelChange)="selecioneSolicitacaoRecebiveisCellcoin($event)">
                  <option value="" *ngIf="!solicitacoesRecebiveisCellcoin.length">
                    Nenhum relatório válido
                  </option>
                  <option *ngFor="let solicitacao of solicitacoesRecebiveisCellcoin"
                          [value]="solicitacao.requestId">
                    {{rotuloSolicitacaoRecebiveisCellcoin(solicitacao)}}
                  </option>
                </select>
              </label>
            </div>

            <form class="cellcoin-statement-filters cellcoin-receivables-filters"
                  *ngIf="isAdmin"
                  (ngSubmit)="soliciteRelatorioRecebiveisCellcoin()">
              <label>
                <span>Liquidação inicial</span>
                <input class="k-textbox" type="date" name="dataInicialRecebiveisCellcoin"
                       [(ngModel)]="dataInicialRecebiveisCellcoin" [disabled]="carregandoRecebiveisCellcoin">
              </label>
              <label>
                <span>Liquidação final</span>
                <input class="k-textbox" type="date" name="dataFinalRecebiveisCellcoin"
                       [(ngModel)]="dataFinalRecebiveisCellcoin" [disabled]="carregandoRecebiveisCellcoin">
              </label>
              <label>
                <span>Status</span>
                <select class="k-textbox" name="statusRecebiveisCellcoin"
                        [(ngModel)]="statusRecebiveisCellcoin" [disabled]="carregandoRecebiveisCellcoin">
                  <option value="pending">Pendentes</option>
                  <option value="payed">Pagos</option>
                  <option value="payedPartial">Pagos parcialmente</option>
                  <option value="">Todos</option>
                </select>
              </label>
              <button kendoButton themeColor="primary" type="submit" [disabled]="carregandoRecebiveisCellcoin">
                <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoRecebiveisCellcoin"></span>
                Gerar relatório
              </button>
            </form>

            <div class="cellcoin-statement-error" *ngIf="erroRecebiveisCellcoin">
              <i class="fas fa-exclamation-circle"></i>
              <span>{{erroRecebiveisCellcoin}}</span>
            </div>

            <div class="cellcoin-receivables-request" *ngIf="relatorioRecebiveisCellcoin">
              <div>
                <span>Protocolo</span>
                <strong class="cellcoin-statement-reference">{{relatorioRecebiveisCellcoin.requestId}}</strong>
              </div>
              <div>
                <span>Status do relatório</span>
                <strong>{{relatorioRecebiveisCellcoin.status || 'PROCESSING'}}</strong>
              </div>
              <div>
                <span>Solicitado em</span>
                <strong>{{relatorioRecebiveisCellcoin.solicitadoEm ?
                  formateDataClienteCellcoin(relatorioRecebiveisCellcoin.solicitadoEm) : '-'}}</strong>
              </div>
              <div>
                <span>Válido até</span>
                <strong>{{relatorioRecebiveisCellcoin.validoAte ?
                  formateDataClienteCellcoin(relatorioRecebiveisCellcoin.validoAte) : 'Aguardando geração'}}</strong>
              </div>
              <button type="button"
                      class="cellcoin-account-btn cellcoin-account-btn-ghost"
                      [disabled]="carregandoRecebiveisCellcoin"
                      (click)="consulteRelatorioRecebiveisCellcoin()">
                <span class="spinner-border spinner-border-sm" *ngIf="carregandoRecebiveisCellcoin"></span>
                <i class="fas fa-sync-alt" *ngIf="!carregandoRecebiveisCellcoin"></i>
                Verificar status
              </button>
            </div>

            <div class="cellcoin-statement-loading"
                 *ngIf="carregandoRecebiveisCellcoin && relatorioRecebiveisCellcoin">
              <span class="spinner-border spinner-border-sm"></span>
              Consultando o relatório de recebíveis na Cellcoin...
            </div>

            <div class="cellcoin-statement-empty"
                 *ngIf="relatorioRecebiveisCellcoin && !relatorioRecebiveisConcluidoCellcoin() &&
                         !carregandoRecebiveisCellcoin && !erroRecebiveisCellcoin">
              <i class="far fa-clock"></i>
              <strong>Relatório em processamento</strong>
              <span>A Celcoin gera este relatório de forma assíncrona. Use “Verificar status” para carregar os valores.</span>
            </div>

            <ng-container *ngIf="relatorioRecebiveisConcluidoCellcoin()">
              <div class="cellcoin-statement-empty"
                   *ngIf="!recebiveisCellcoin.length && !carregandoRecebiveisCellcoin && !erroRecebiveisCellcoin">
                <i class="far fa-folder-open"></i>
                <strong>Nenhum recebível encontrado</strong>
                <span>O relatório foi concluído sem registros para os filtros informados.</span>
              </div>

              <div class="cellcoin-receivables-summary" *ngIf="recebiveisCellcoin.length">
                <div>
                  <span>Recebíveis</span>
                  <strong>{{recebiveisCellcoin.length}}</strong>
                </div>
                <div>
                  <span>Valor bruto</span>
                  <strong>{{formateMoedaCellcoin(totalRecebiveisCellcoin('grossValue'))}}</strong>
                </div>
                <div>
                  <span>Valor líquido</span>
                  <strong>{{formateMoedaCellcoin(totalRecebiveisCellcoin('netValue'))}}</strong>
                </div>
                <div>
                  <span>Valor liquidado</span>
                  <strong>{{formateMoedaCellcoin(totalRecebiveisCellcoin('settledValue'))}}</strong>
                </div>
              </div>

              <div class="cellcoin-statement-table-wrap" *ngIf="recebiveisCellcoin.length">
                <table class="cellcoin-statement-table cellcoin-receivables-table">
                  <thead>
                  <tr>
                    <th>Transação</th>
                    <th>Parcela</th>
                    <th>Bandeira</th>
                    <th>Operação</th>
                    <th>Status</th>
                    <th>Data da operação</th>
                    <th>Previsão original</th>
                    <th>Liquidação</th>
                    <th class="cellcoin-statement-number">Bruto</th>
                    <th class="cellcoin-statement-number">Taxas</th>
                    <th class="cellcoin-statement-number">Líquido</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let recebivel of recebiveisCellcoin">
                    <td>
                      <strong class="cellcoin-statement-reference">{{recebivel.transactionId || '-'}}</strong>
                      <span class="cellcoin-statement-reference">ID: {{recebivel.id || '-'}}</span>
                    </td>
                    <td>{{recebivel.installment || '-'}}</td>
                    <td>{{recebivel.brand || '-'}}</td>
                    <td>{{recebivel.operation || '-'}}</td>
                    <td><span class="cellcoin-charge-status">{{rotuloStatusRecebivelCellcoin(recebivel.status)}}</span></td>
                    <td>{{formateDataConsolidadoCellcoin(recebivel.operationDate)}}</td>
                    <td>{{formateDataConsolidadoCellcoin(recebivel.originalSettlementDate)}}</td>
                    <td>
                      {{formateDataConsolidadoCellcoin(recebivel.settledDate || recebivel.advancementDate)}}
                    </td>
                    <td class="cellcoin-statement-number cellcoin-statement-amount">
                      {{formateMoedaCellcoin(recebivel.grossValue)}}
                    </td>
                    <td class="cellcoin-statement-number">
                      {{formateMoedaCellcoin(totalTaxasRecebivelCellcoin(recebivel))}}
                    </td>
                    <td class="cellcoin-statement-number cellcoin-statement-amount">
                      {{formateMoedaCellcoin(recebivel.netValue)}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </div>
        </article>
      </section>

      <section *ngIf="aba === 'clientes'" class="cellcoin-account-tab-panel">
        <article class="cellcoin-account-panel">
          <div class="cellcoin-account-panel-header cellcoin-statement-header">
            <div>
              <div class="cellcoin-account-section-title"><i class="fas fa-users"></i> Clientes da conta</div>
              <span>Customers criados para esta conta na Cellcoin.</span>
            </div>
            <button type="button"
                    class="cellcoin-account-btn cellcoin-account-btn-ghost"
                    [disabled]="carregandoClientesCellcoin"
                    (click)="carregueClientesCellcoin(paginaClientesCellcoin)">
              <span class="spinner-border spinner-border-sm" *ngIf="carregandoClientesCellcoin"></span>
              <i class="fas fa-sync-alt" *ngIf="!carregandoClientesCellcoin"></i>
              Atualizar
            </button>
          </div>

          <div class="cellcoin-account-panel-body">
            <div class="alert alert-danger" *ngIf="erroClientesCellcoin">{{erroClientesCellcoin}}</div>

            <div class="cellcoin-statement-loading" *ngIf="carregandoClientesCellcoin && !clientesCellcoin.length">
              <span class="spinner-border spinner-border-sm"></span>
              Consultando clientes na Cellcoin...
            </div>

            <div class="cellcoin-statement-empty"
                 *ngIf="clientesConsultadosCellcoin && !carregandoClientesCellcoin &&
                         !erroClientesCellcoin && !clientesCellcoin.length">
              <i class="far fa-folder-open"></i>
              <strong>Nenhum cliente encontrado</strong>
              <span>A Cellcoin não retornou Customers criados para esta conta.</span>
            </div>

            <div class="cellcoin-statement-table-wrap" *ngIf="clientesCellcoin.length">
              <table class="cellcoin-statement-table">
                <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Documento</th>
                  <th>Identificadores</th>
                  <th>Contato</th>
                  <th>Criado em</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let cliente of clientesCellcoin">
                  <td><strong>{{cliente.name || cliente.fullName || '-'}}</strong></td>
                  <td><span class="cellcoin-statement-reference">{{cliente.document || cliente.documentNumber || '-'}}</span></td>
                  <td>
                    <strong>GalaxPay ID: {{cliente.galaxPayId || '-'}}</strong>
                    <span class="cellcoin-statement-reference">myId: {{cliente.myId || '-'}}</span>
                  </td>
                  <td>
                    <strong>{{emailClienteCellcoin(cliente)}}</strong>
                    <span>{{telefoneClienteCellcoin(cliente)}}</span>
                  </td>
                  <td>{{formateDataClienteCellcoin(cliente.createdAt || cliente.createDate)}}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="cellcoin-statement-pagination"
                 *ngIf="clientesCellcoin.length &&
                         (paginaClientesCellcoin > 1 || possuiProximaPaginaClientesCellcoin)">
              <span>
                {{totalClientesCellcoin}} cliente(s) · Página {{paginaClientesCellcoin}}
                <ng-container *ngIf="totalPaginasClientesCellcoin">
                  de {{totalPaginasClientesCellcoin}}
                </ng-container>
              </span>
              <div>
                <button type="button" class="cellcoin-account-btn" title="Página anterior"
                        [disabled]="paginaClientesCellcoin <= 1 || carregandoClientesCellcoin"
                        (click)="paginaAnteriorClientesCellcoin()">
                  <i class="fas fa-chevron-left"></i>
                </button>
                <button type="button" class="cellcoin-account-btn" title="Próxima página"
                        [disabled]="!possuiProximaPaginaClientesCellcoin || carregandoClientesCellcoin"
                        (click)="proximaPaginaClientesCellcoin()">
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>
      </section>

      <section *ngIf="aba === 'recorrencias'" class="cellcoin-account-tab-panel">
        <article class="cellcoin-account-panel">
          <div class="cellcoin-account-panel-header cellcoin-statement-header">
            <div>
              <div class="cellcoin-account-section-title"><i class="fas fa-sync-alt"></i> Recorrências Pix Automático</div>
              <span>Recorrências cadastradas na Celcoin para esta conta.</span>
            </div>
          </div>
          <div class="cellcoin-account-panel-body">
            <form class="cellcoin-statement-filters" (ngSubmit)="carregueRecorrenciasCellcoin()">
              <label>
                <span>Cadastro a partir de</span>
                <input class="k-textbox" type="date" name="dataInicialRecorrenciasCellcoin"
                       [(ngModel)]="dataInicialRecorrenciasCellcoin" [disabled]="carregandoRecorrenciasCellcoin">
              </label>
              <label>
                <span>Cadastro até</span>
                <input class="k-textbox" type="date" name="dataFinalRecorrenciasCellcoin"
                       [(ngModel)]="dataFinalRecorrenciasCellcoin" [disabled]="carregandoRecorrenciasCellcoin">
              </label>
              <label>
                <span>Status</span>
                <select class="form-control" name="statusRecorrenciasCellcoin"
                        [(ngModel)]="statusRecorrenciasCellcoin" [disabled]="carregandoRecorrenciasCellcoin">
                  <option value="">Todos</option>
                  <option value="CREATED">Criada</option>
                  <option value="PENDING_DEBIT_PARTY">Aguardando pagador</option>
                  <option value="PENDING_CREDIT_PARTY">Aguardando recebedor</option>
                  <option value="CONFIRMED">Confirmada</option>
                  <option value="DENIED">Negada</option>
                  <option value="REJECTED">Rejeitada</option>
                  <option value="CANCELLATION_REQUEST">Cancelamento solicitado</option>
                  <option value="CANCELLING">Em cancelamento</option>
                  <option value="CANCELLED">Cancelada</option>
                  <option value="EXPIRED">Expirada</option>
                  <option value="ERROR">Erro</option>
                </select>
              </label>
              <button type="submit" class="cellcoin-account-btn" [disabled]="carregandoRecorrenciasCellcoin">
                <i class="fas fa-search"></i> Consultar
              </button>
            </form>
            <div class="alert alert-danger" *ngIf="erroRecorrenciasCellcoin">{{erroRecorrenciasCellcoin}}</div>
            <div class="cellcoin-statement-loading" *ngIf="carregandoRecorrenciasCellcoin">
              <span class="spinner-border spinner-border-sm"></span> Consultando recorrências na Celcoin...
            </div>
            <div class="cellcoin-statement-empty"
                 *ngIf="recorrenciasConsultadasCellcoin && !carregandoRecorrenciasCellcoin &&
                         !erroRecorrenciasCellcoin && !recorrenciasCellcoin.length">
              <strong>Nenhuma recorrência encontrada</strong>
              <span>Não há recorrências para os filtros informados.</span>
            </div>
            <div class="cellcoin-statement-table-wrap" *ngIf="recorrenciasCellcoin.length">
              <table class="cellcoin-statement-table">
                <thead><tr>
                  <th>Recorrência</th><th>Cliente / contrato</th><th>Status / jornadas</th>
                  <th>Valor</th><th>Periodicidade / início</th><th>Cadastrada em</th>
                </tr></thead>
                <tbody>
                  <tr *ngFor="let recorrencia of recorrenciasCellcoin">
                    <td>
                      <strong class="text-break">{{recorrencia.recurrencyId}}</strong>
                      <span class="cellcoin-statement-reference text-break">{{recorrencia.clientRequestId}}</span>
                    </td>
                    <td>
                      <strong>{{recorrencia.debtor?.name || '-'}}</strong>
                      <span>{{recorrencia.debtor?.taxId || '-'}}</span>
                      <span>Contrato: {{recorrencia.contract?.number || '-'}}</span>
                    </td>
                    <td>
                      <strong>{{recorrencia.status}}</strong>
                      <span *ngFor="let jornada of recorrencia.journeys">Jornada {{jornada.type}}: {{jornada.status}}</span>
                    </td>
                    <td>
                      <ng-container *ngIf="recorrencia.amount != null; else valorVariavelRecorrencia">
                        {{recorrencia.amount | currency:'BRL'}}
                      </ng-container>
                      <ng-template #valorVariavelRecorrencia>
                        Variável
                        <span *ngIf="recorrencia.recurrencyMinAmount != null">
                          Mínimo: {{recorrencia.recurrencyMinAmount | currency:'BRL'}}
                        </span>
                      </ng-template>
                    </td>
                    <td>
                      <strong>{{recorrencia.interval?.frequencyType || '-'}}</strong>
                      <span>{{recorrencia.interval?.start || '-'}}</span>
                    </td>
                    <td>{{formateDataClienteCellcoin(recorrencia.createDate)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="cellcoin-statement-pagination"
                 *ngIf="recorrenciasConsultadasCellcoin && !erroRecorrenciasCellcoin && !carregandoRecorrenciasCellcoin">
              <span>Página {{paginaRecorrenciasCellcoin + 1}}</span>
              <div>
                <button type="button" class="cellcoin-account-btn" [disabled]="paginaRecorrenciasCellcoin <= 0"
                        (click)="carregueRecorrenciasCellcoin(paginaRecorrenciasCellcoin - 1, false)">Anterior</button>
                <button type="button" class="cellcoin-account-btn" [disabled]="!possuiProximaPaginaRecorrenciasCellcoin"
                        (click)="carregueRecorrenciasCellcoin(paginaRecorrenciasCellcoin + 1, false)">Próxima</button>
              </div>
            </div>
          </div>
        </article>
      </section>

      <section *ngIf="aba === 'cobrancas'" class="cellcoin-account-tab-panel">
        <article class="cellcoin-account-panel">
          <div class="cellcoin-account-panel-header cellcoin-statement-header">
            <div>
              <div class="cellcoin-account-section-title"><i class="fas fa-file-invoice-dollar"></i> Cobranças Cellcoin</div>
              <span>Consulte separadamente as cobranças Pix e as charges de cartão criadas para esta conta.</span>
            </div>
          </div>

          <div class="cellcoin-account-panel-body">
            <div class="cellcoin-charge-type-tabs">
              <button type="button"
                      *ngIf="pixLiberadoCellcoin()"
                      [class.active]="tipoCobrancaCellcoin === 'pix'"
                      (click)="selecioneTipoCobrancaCellcoin('pix')">
                <i class="fas fa-qrcode"></i>
                Pix
              </button>
              <button type="button"
                      *ngIf="cartaoLiberadoCellcoin()"
                      [class.active]="tipoCobrancaCellcoin === 'cartao'"
                      (click)="selecioneTipoCobrancaCellcoin('cartao')">
                <i class="far fa-credit-card"></i>
                Cartão
              </button>
            </div>

            <div class="cellcoin-statement-empty" *ngIf="!tipoCobrancaCellcoin">
              <i class="far fa-folder-open"></i>
              <strong>Nenhuma modalidade liberada</strong>
              <span>Libere o Pix ou o cartão para consultar as cobranças desta conta.</span>
            </div>

            <form class="cellcoin-statement-filters cellcoin-charge-filters"
                  *ngIf="tipoCobrancaCellcoin"
                  (ngSubmit)="carregueCobrancasCellcoin()">
              <label>
                <span>Data inicial</span>
                <input class="k-textbox" type="date" name="dataInicialCobrancasCellcoin"
                       [(ngModel)]="dataInicialCobrancasCellcoin" [disabled]="carregandoCobrancasCellcoin">
              </label>
              <label>
                <span>Data final</span>
                <input class="k-textbox" type="date" name="dataFinalCobrancasCellcoin"
                       [(ngModel)]="dataFinalCobrancasCellcoin" [disabled]="carregandoCobrancasCellcoin">
              </label>
              <button kendoButton themeColor="primary" type="submit" [disabled]="carregandoCobrancasCellcoin">
                <span class="spinner-border spinner-border-sm mr-1" *ngIf="carregandoCobrancasCellcoin"></span>
                Consultar
              </button>
            </form>

            <div class="cellcoin-statement-error" *ngIf="tipoCobrancaCellcoin && erroCobrancasCellcoin">
              <i class="fas fa-exclamation-circle"></i>
              <span>{{erroCobrancasCellcoin}}</span>
            </div>

            <div class="cellcoin-statement-loading" *ngIf="tipoCobrancaCellcoin && carregandoCobrancasCellcoin">
              <span class="spinner-border spinner-border-sm"></span>
              Consultando cobranças {{tipoCobrancaCellcoin === 'pix' ? 'Pix' : 'de cartão'}} na Cellcoin...
            </div>

            <ng-container *ngIf="tipoCobrancaCellcoin === 'pix' && !carregandoCobrancasCellcoin">
              <div class="cellcoin-statement-empty"
                   *ngIf="retornoCobrancasPixCellcoin && !cobrancasPixCellcoin.length && !erroCobrancasCellcoin">
                <i class="far fa-folder-open"></i>
                <strong>Nenhuma cobrança Pix encontrada</strong>
                <span>Não foram retornadas cobranças Pix para a conta e o período informados.</span>
              </div>

              <div class="cellcoin-statement-table-wrap" *ngIf="cobrancasPixCellcoin.length">
                <table class="cellcoin-statement-table cellcoin-charges-table">
                  <thead>
                  <tr>
                    <th>Identificação</th>
                    <th>Pagador</th>
                    <th>Data</th>
                    <th>Status</th>
                    <th class="cellcoin-statement-number">Valor</th>
                    <th class="cellcoin-statement-number">Confirmado</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let cobranca of cobrancasPixCellcoin">
                    <td>
                      <strong class="cellcoin-statement-reference">{{cobranca.externalId || cobranca.transactionId || '-'}}</strong>
                      <span class="cellcoin-statement-reference" *ngIf="cobranca.pix?.transactionIdentification">
                        {{cobranca.pix.transactionIdentification}}
                      </span>
                    </td>
                    <td>
                      <strong>{{cobranca.debtor?.name || '-'}}</strong>
                      <span>{{cobranca.debtor?.document || '-'}}</span>
                    </td>
                    <td>{{formateDataCobrancaCellcoin(cobranca.createdAt || cobranca.duedate)}}</td>
                    <td><span class="cellcoin-charge-status">{{statusCobrancaPixCellcoin(cobranca)}}</span></td>
                    <td class="cellcoin-statement-number cellcoin-statement-amount">
                      {{formateMoedaCellcoin(cobranca.amount)}}
                    </td>
                    <td class="cellcoin-statement-number">
                      {{cobranca.amountConfirmed == null ? '-' : formateMoedaCellcoin(cobranca.amountConfirmed)}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="cellcoin-statement-pagination" *ngIf="totalPaginasCobrancasPixCellcoin > 1">
                <span>Página {{paginaCobrancasPixCellcoin}} de {{totalPaginasCobrancasPixCellcoin}}</span>
                <div>
                  <button type="button" class="cellcoin-account-btn" title="Página anterior"
                          [disabled]="paginaCobrancasPixCellcoin <= 1"
                          (click)="paginaAnteriorCobrancasPixCellcoin()">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button type="button" class="cellcoin-account-btn" title="Próxima página"
                          [disabled]="paginaCobrancasPixCellcoin >= totalPaginasCobrancasPixCellcoin"
                          (click)="proximaPaginaCobrancasPixCellcoin()">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="tipoCobrancaCellcoin === 'cartao' && !carregandoCobrancasCellcoin">
              <div class="cellcoin-statement-empty"
                   *ngIf="retornoCobrancasCartaoCellcoin && !cobrancasCartaoCellcoin.length && !erroCobrancasCellcoin">
                <i class="far fa-folder-open"></i>
                <strong>Nenhuma charge de cartão encontrada</strong>
                <span>Não foram retornadas charges para a conta e o período informados.</span>
              </div>

              <div class="cellcoin-statement-table-wrap" *ngIf="cobrancasCartaoCellcoin.length">
                <table class="cellcoin-statement-table cellcoin-charges-table">
                  <thead>
                  <tr>
                    <th>Charge</th>
                    <th>Cliente</th>
                    <th>Criada em</th>
                    <th>Status</th>
                    <th>Cartão</th>
                    <th class="cellcoin-statement-number">Valor</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let cobranca of cobrancasCartaoCellcoin">
                    <td>
                      <strong class="cellcoin-statement-reference">{{cobranca.myId || '-'}}</strong>
                      <span>GalaxPay ID: {{cobranca.galaxPayId || '-'}}</span>
                    </td>
                    <td>
                      <strong>{{clienteCobrancaCartaoCellcoin(cobranca).name || '-'}}</strong>
                      <span>{{clienteCobrancaCartaoCellcoin(cobranca).document || '-'}}</span>
                    </td>
                    <td>{{formateDataCobrancaCellcoin(cobranca.createdAt)}}</td>
                    <td><span class="cellcoin-charge-status">{{statusCobrancaCartaoCellcoin(cobranca)}}</span></td>
                    <td>
                      <strong>{{bandeiraCobrancaCartaoCellcoin(cobranca) || '-'}}</strong>
                      <span class="cellcoin-statement-reference">
                        {{transacaoCobrancaCartaoCellcoin(cobranca).tid || transacaoCobrancaCartaoCellcoin(cobranca).authorizationCode || '-'}}
                      </span>
                    </td>
                    <td class="cellcoin-statement-number cellcoin-statement-amount">
                      {{formateCentavosCellcoin(cobranca.value)}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="cellcoin-statement-pagination"
                   *ngIf="paginaCobrancasCartaoCellcoin > 1 || possuiProximaPaginaCobrancasCartaoCellcoin">
                <span>
                  Página {{paginaCobrancasCartaoCellcoin}}
                  <ng-container *ngIf="totalPaginasCobrancasCartaoCellcoin">
                    de {{totalPaginasCobrancasCartaoCellcoin}}
                  </ng-container>
                </span>
                <div>
                  <button type="button" class="cellcoin-account-btn" title="Página anterior"
                          [disabled]="paginaCobrancasCartaoCellcoin <= 1"
                          (click)="paginaAnteriorCobrancasCartaoCellcoin()">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button type="button" class="cellcoin-account-btn" title="Próxima página"
                          [disabled]="!possuiProximaPaginaCobrancasCartaoCellcoin"
                          (click)="proximaPaginaCobrancasCartaoCellcoin()">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </article>
      </section>

      <section *ngIf="aba === 'chargebacks'" class="cellcoin-account-tab-panel">
        <article class="cellcoin-account-panel">
          <div class="cellcoin-account-panel-header cellcoin-statement-header">
            <div>
              <div class="cellcoin-account-section-title"><i class="fas fa-shield-alt"></i> Chargebacks da conta</div>
              <span>Disputas retornadas pela Cellcoin e seus pagamentos relacionados no Meu Cardápio Pay.</span>
            </div>
            <button type="button"
                    class="cellcoin-account-btn cellcoin-account-btn-ghost"
                    [disabled]="carregandoChargebacksCellcoin || importandoChargebackCellcoin != null"
                    (click)="carregueChargebacksCellcoin()">
              <span class="spinner-border spinner-border-sm" *ngIf="carregandoChargebacksCellcoin"></span>
              <i class="fas fa-sync-alt" *ngIf="!carregandoChargebacksCellcoin"></i>
              Atualizar
            </button>
          </div>

          <div class="cellcoin-account-panel-body">
            <div class="cellcoin-chargeback-summary" *ngIf="chargebacksConsultadosCellcoin">
              <strong>{{chargebacksCellcoin.length}}</strong>
              <span>chargeback(s) localizado(s) para a conta {{contaDetalhesContaCellcoin()}}</span>
            </div>

            <div class="alert alert-danger" *ngIf="erroChargebacksCellcoin">{{erroChargebacksCellcoin}}</div>
            <div class="alert alert-success" *ngIf="mensagemChargebacksCellcoin">{{mensagemChargebacksCellcoin}}</div>

            <div class="cellcoin-chargeback-loading" *ngIf="carregandoChargebacksCellcoin && !chargebacksCellcoin.length">
              <span class="spinner-border spinner-border-sm"></span>
              Consultando chargebacks e pagamentos relacionados...
            </div>

            <div class="cellcoin-chargeback-empty"
                 *ngIf="chargebacksConsultadosCellcoin && !carregandoChargebacksCellcoin &&
                         !erroChargebacksCellcoin && !chargebacksCellcoin.length">
              <i class="far fa-check-circle"></i>
              <strong>Nenhum chargeback encontrado</strong>
              <span>A Cellcoin não retornou disputas para esta conta.</span>
            </div>

            <div class="cellcoin-chargeback-table-wrap" *ngIf="chargebacksCellcoin.length">
              <table class="cellcoin-chargeback-table">
                <thead>
                <tr>
                  <th>Chargeback</th>
                  <th>Status</th>
                  <th>Valor e prazo</th>
                  <th>Pagamento</th>
                  <th class="cellcoin-chargeback-action-column">Importação</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let chargeback of chargebacksCellcoin">
                  <td>
                    <strong>#{{chargeback.galaxPayId}}</strong>
                    <span>Processo {{chargeback.process || '-'}}</span>
                    <small>{{chargeback.description || 'Sem descrição'}}</small>
                  </td>
                  <td>
                    <span class="cellcoin-chargeback-status"
                          [ngClass]="classeStatusChargebackCellcoin(chargeback.status)">
                      {{rotuloStatusChargebackCellcoin(chargeback.status)}}
                    </span>
                  </td>
                  <td>
                    <strong>{{formateMoedaCellcoin(chargeback.value)}}</strong>
                    <span>Aberto em {{formateDataChargebackCellcoin(chargeback.createdAt)}}</span>
                    <small>Prazo: {{formateDataChargebackCellcoin(chargeback.expire)}}</small>
                  </td>
                  <td>
                    <ng-container *ngIf="chargeback.pagamento; else pagamentoChargebackNaoEncontrado">
                      <strong>Pedido {{chargeback.pagamento.pedido?.codigo || chargeback.pagamento.pedido?.id}}</strong>
                      <span>Pagamento #{{chargeback.pagamento.id}}</span>
                      <small>Transação {{chargeback.pagamento.codigoAdquirente || '-'}}</small>
                    </ng-container>
                    <ng-template #pagamentoChargebackNaoEncontrado>
                      <span class="cellcoin-chargeback-not-found">
                        <i class="fas fa-exclamation-circle"></i>
                        Pagamento não localizado
                      </span>
                    </ng-template>
                  </td>
                  <td class="cellcoin-chargeback-action-column">
                    <span class="cellcoin-chargeback-imported" *ngIf="chargeback.importado">
                      <i class="fas fa-check-circle"></i>
                      Importado
                    </span>
                    <button kendoButton
                            themeColor="primary"
                            *ngIf="isAdmin && chargeback.aguardandoDocumentacao && !chargeback.importado"
                            [title]="chargeback.pagamento ? 'Importar chargeback' : 'Pagamento não localizado nesta empresa'"
                            [disabled]="importandoChargebackCellcoin != null || !chargeback.podeImportar"
                            (click)="importeChargebackCellcoin(chargeback)">
                      <span class="spinner-border spinner-border-sm mr-1"
                            *ngIf="chargebackCellcoinEmImportacao(chargeback)"></span>
                      Importar
                    </button>
                    <span class="cellcoin-chargeback-unavailable"
                          *ngIf="!chargeback.importado && !chargeback.aguardandoDocumentacao">
                      Indisponível neste status
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </article>
      </section>

      <section *ngIf="aba === 'auditoria'" class="cellcoin-account-tab-panel">
        <article class="cellcoin-account-panel">
          <div class="cellcoin-account-panel-header">
            <div class="cellcoin-account-section-title">Auditoria da consulta</div>
          </div>
          <div class="cellcoin-account-panel-body">
            <div class="cellcoin-account-data-grid">
              <div class="cellcoin-account-field">
                <div class="cellcoin-account-field-label"><i class="fas fa-plug"></i> Endpoint</div>
                <div class="cellcoin-account-field-value">{{endpointDetalhesContaCellcoin()}}</div>
              </div>
              <div class="cellcoin-account-field">
                <div class="cellcoin-account-field-label"><i class="far fa-building"></i> Tipo</div>
                <div class="cellcoin-account-field-value">{{tipoDetalhesContaCellcoin()}}</div>
              </div>
              <div class="cellcoin-account-field">
                <div class="cellcoin-account-field-label"><i class="fas fa-wallet"></i> Saldo consultado</div>
                <div class="cellcoin-account-field-value">{{detalhesContaCellcoin?.saldoErro || formateMoedaCellcoin(saldoDetalhesContaCellcoin())}}</div>
              </div>
              <div class="cellcoin-account-field">
                <div class="cellcoin-account-field-label"><i class="far fa-check-circle"></i> Status</div>
                <div class="cellcoin-account-field-value">{{statusDetalhesContaCellcoin()}}</div>
              </div>
            </div>
          </div>
        </article>
      </section>
    </ng-container>
  </main>
</div>

<kendo-dialog *ngIf="modalConfirmacaoContaCellcoin"
              [title]="modalConfirmacaoContaCellcoin.titulo"
              (close)="fecheConfirmacaoContaCellcoin()"
              [minWidth]="320"
              [width]="520">
  <div class="cellcoin-account-confirmation">
    <div class="cellcoin-account-confirmation-header">
      <div class="cellcoin-account-confirmation-icon"
           [ngClass]="{'cellcoin-account-confirmation-danger': modalConfirmacaoContaCellcoin.acao === 'encerrar'}">
        <i class="fas" [ngClass]="modalConfirmacaoContaCellcoin.acao === 'encerrar' ? 'fa-exclamation-triangle' : 'fa-lock'"></i>
      </div>
      <p>{{modalConfirmacaoContaCellcoin.mensagem}}</p>
    </div>

    <div class="cellcoin-account-confirmation-summary">
      <div>
        <span>Conta</span>
        <strong>{{contaDetalhesContaCellcoin()}}</strong>
      </div>
      <div>
        <span>Documento</span>
        <strong>{{documentoDetalhesContaCellcoin()}}</strong>
      </div>
      <div>
        <span>Status</span>
        <strong>{{statusDetalhesContaCellcoin()}}</strong>
      </div>
      <div>
        <span>Saldo</span>
        <strong>{{formateMoedaCellcoin(saldoDetalhesContaCellcoin())}}</strong>
      </div>
    </div>

    <div class="cellcoin-account-confirmation-error" *ngIf="modalConfirmacaoContaCellcoin.erro">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{modalConfirmacaoContaCellcoin.erro}}</span>
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton
            [disabled]="!!executandoAcao"
            (click)="fecheConfirmacaoContaCellcoin()">
      Cancelar
    </button>
    <button kendoButton
            [themeColor]="modalConfirmacaoContaCellcoin.acao === 'encerrar' ? 'error' : 'primary'"
            [disabled]="!!executandoAcao"
            (click)="confirmeAcaoContaCellcoin()">
      <span class="spinner-border spinner-border-sm mr-1" *ngIf="!!executandoAcao"></span>
      {{modalConfirmacaoContaCellcoin.textoBotao}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="modalConfirmacaoTransferenciaCellcoin"
              title="Transferência Pix"
              (close)="fecheConfirmacaoTransferenciaCellcoin()"
              [minWidth]="320"
              [width]="620">
  <div class="cellcoin-bank-transfer">
    <div class="cellcoin-bank-transfer-steps">
      <div [class.active]="etapaTransferenciaCellcoin === 'codigo'"
           [class.done]="etapaTransferenciaCellcoin === 'chaves' || etapaTransferenciaCellcoin === 'valor' || etapaTransferenciaCellcoin === 'resumo' || etapaAcompanhamentoTransferenciaPixCellcoin()">
        <span>1</span><small>Segurança</small>
      </div>
      <div [class.active]="etapaTransferenciaCellcoin === 'chaves'"
           [class.done]="etapaTransferenciaCellcoin === 'valor' || etapaTransferenciaCellcoin === 'resumo' || etapaAcompanhamentoTransferenciaPixCellcoin()">
        <span>2</span><small>Chave</small>
      </div>
      <div [class.active]="etapaTransferenciaCellcoin === 'valor'"
           [class.done]="etapaTransferenciaCellcoin === 'resumo' || etapaAcompanhamentoTransferenciaPixCellcoin()">
        <span>3</span><small>Valor</small>
      </div>
      <div [class.active]="etapaTransferenciaCellcoin === 'resumo'"
           [class.done]="etapaAcompanhamentoTransferenciaPixCellcoin()">
        <span>4</span><small>Confirmar</small>
      </div>
    </div>

    <div class="cellcoin-bank-transfer-timer"
         *ngIf="segundosRestantesTransferenciaCellcoin > 0">
      <i class="far fa-clock"></i>
      {{etapaTransferenciaCellcoin === 'codigo' ? 'Código expira em' : 'Sessão expira em'}}
      <strong>{{tempoRestanteTransferenciaPixCellcoin()}}</strong>
    </div>

    <div class="alert alert-info" *ngIf="mensagemFluxoTransferenciaCellcoin">
      {{mensagemFluxoTransferenciaCellcoin}}
    </div>
    <div class="cellcoin-account-confirmation-error"
         *ngIf="erroFluxoTransferenciaCellcoin && etapaTransferenciaCellcoin !== 'falha'">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{erroFluxoTransferenciaCellcoin}}</span>
    </div>

    <section class="cellcoin-bank-transfer-stage cellcoin-bank-transfer-expired"
             *ngIf="etapaTransferenciaCellcoin === 'expirado'">
      <div class="cellcoin-bank-transfer-stage-icon"><i class="far fa-clock"></i></div>
      <h3>O tempo da transferência encerrou</h3>
      <p>Por segurança, este fluxo foi cancelado. Inicie novamente para receber um novo código por e-mail.</p>
    </section>

    <section class="cellcoin-bank-transfer-stage" *ngIf="etapaTransferenciaCellcoin === 'codigo'">
      <div class="cellcoin-bank-transfer-stage-icon"><i class="fas fa-envelope"></i></div>
      <h3>Confirme que é você</h3>
      <p *ngIf="solicitandoCodigoTransferenciaCellcoin">
        <span class="spinner-border spinner-border-sm mr-1"></span>
        Enviando o código de segurança...
      </p>
      <p *ngIf="!solicitandoCodigoTransferenciaCellcoin && emailAutorizacaoTransferenciaCellcoin">
        Enviamos um código de seis dígitos para <strong>{{emailAutorizacaoTransferenciaCellcoin}}</strong>.
      </p>
      <label class="cellcoin-bank-transfer-code">
        <span>Código recebido por e-mail</span>
        <input class="k-textbox"
               type="text"
               inputmode="numeric"
               pattern="[0-9]*"
               maxlength="6"
               autocomplete="one-time-code"
               [(ngModel)]="codigoTransferenciaCellcoin"
               [disabled]="solicitandoCodigoTransferenciaCellcoin || validandoCodigoTransferenciaCellcoin || !emailAutorizacaoTransferenciaCellcoin"
               (input)="normalizeCodigoTransferenciaPixCellcoin()"
               (keyup.enter)="valideCodigoTransferenciaPixCellcoin()"
               placeholder="000000">
      </label>
      <button type="button"
              class="cellcoin-bank-transfer-link"
              [disabled]="solicitandoCodigoTransferenciaCellcoin || validandoCodigoTransferenciaCellcoin"
              (click)="soliciteCodigoTransferenciaPixCellcoin()">
        Reenviar código
      </button>
    </section>

    <section class="cellcoin-bank-transfer-stage" *ngIf="etapaTransferenciaCellcoin === 'chaves'">
      <div class="cellcoin-bank-transfer-stage-heading">
        <div>
          <span>Destino da transferência</span>
          <h3>Minhas chaves</h3>
          <p>Escolha uma chave permitida para consultar o destinatário no DICT.</p>
        </div>
        <i class="fas fa-key"></i>
      </div>
      <div class="cellcoin-bank-transfer-keys">
        <button type="button"
                *ngFor="let chave of opcoesChavesTransferenciaPixCellcoin; trackBy: trackByChaveTransferenciaPixCellcoin"
                [disabled]="consultandoDestinoTransferenciaCellcoin"
                [class.test]="chave.homologacao"
                [class.selected]="chaveSelecionadaTransferenciaCellcoin?.chave === chave.chave"
                (click)="selecioneChaveTransferenciaPixCellcoin(chave)">
          <span class="cellcoin-bank-transfer-key-icon">
            <i class="fas" [ngClass]="iconeTipoChavePixCellcoin(chave)"></i>
          </span>
          <span>
            <strong>
              {{chave.homologacao ? 'Chave de teste' : (chave.salva ? rotuloTipoChavePixCellcoin(chave.tipo) + ' salva' : chave.tipo)}}
            </strong>
            <b>
              {{chave.personalizada ? formateNovaChavePixCellcoin(chave.chave, chave.tipo) : formateChaveTransferenciaPixCellcoin(chave.chave)}}
            </b>
            <small *ngIf="!consultandoDestinoTransferenciaCellcoin || chaveSelecionadaTransferenciaCellcoin?.chave !== chave.chave">
              {{chave.descricao}}
            </small>
            <small *ngIf="consultandoDestinoTransferenciaCellcoin && chaveSelecionadaTransferenciaCellcoin?.chave === chave.chave">
              Consultando destinatário e saldo...
            </small>
          </span>
          <span class="spinner-border spinner-border-sm"
                *ngIf="consultandoDestinoTransferenciaCellcoin && chaveSelecionadaTransferenciaCellcoin?.chave === chave.chave"></span>
          <i class="fas fa-chevron-right"
             *ngIf="!consultandoDestinoTransferenciaCellcoin || chaveSelecionadaTransferenciaCellcoin?.chave !== chave.chave"></i>
        </button>

        <div class="cellcoin-bank-transfer-saved-loading"
             *ngIf="carregandoChavesSalvasTransferenciaCellcoin">
          <span class="spinner-border spinner-border-sm"></span>
          Carregando chaves salvas...
        </div>

        <button type="button"
                class="cellcoin-bank-transfer-new-key-button"
                [class.selected]="informandoNovaChaveTransferenciaCellcoin"
                [disabled]="consultandoDestinoTransferenciaCellcoin || carregandoChavesSalvasTransferenciaCellcoin"
                (click)="abraNovaChaveTransferenciaPixCellcoin()">
          <span class="cellcoin-bank-transfer-key-icon"><i class="fas fa-plus"></i></span>
          <span>
            <strong>Outra chave</strong>
            <b>Informar uma nova chave Pix</b>
            <small>E-mail, telefone celular ou chave aleatória</small>
          </span>
          <i class="fas fa-chevron-down"></i>
        </button>
      </div>

      <div class="cellcoin-bank-transfer-new-key" *ngIf="informandoNovaChaveTransferenciaCellcoin">
        <div class="cellcoin-bank-transfer-owner-warning">
          <i class="fas fa-shield-alt"></i>
          <span>
            A chave precisa estar vinculada ao <strong>CNPJ da empresa</strong> ou ao
            <strong>CPF do responsável</strong> cadastrado na conta Cellcoin.
          </span>
        </div>

        <label>
          <span>Digite a chave Pix</span>
          <input class="k-textbox"
                 type="text"
                 maxlength="77"
                 autocomplete="off"
                 [disabled]="consultandoDestinoTransferenciaCellcoin"
                 [(ngModel)]="novaChaveTransferenciaCellcoin"
                 (input)="identifiqueNovaChaveTransferenciaPixCellcoin()"
                 placeholder="E-mail, celular com DDD ou chave aleatória">
        </label>

        <small class="cellcoin-bank-transfer-new-key-hint"
               *ngIf="novaChaveTransferenciaCellcoin && !novaChaveIdentificadaTransferenciaCellcoin">
          Informe um e-mail, celular com DDD ou chave aleatória válida.
        </small>

        <label class="cellcoin-bank-transfer-save-key"
               *ngIf="novaChaveIdentificadaTransferenciaCellcoin">
          <input type="checkbox"
                 [disabled]="consultandoDestinoTransferenciaCellcoin"
                 [(ngModel)]="salvarNovaChaveTransferenciaCellcoin">
          <span>Salvar para futuras transferências</span>
        </label>

        <button type="button"
                class="cellcoin-bank-transfer-new-key-result"
                *ngIf="novaChaveIdentificadaTransferenciaCellcoin"
                [disabled]="consultandoDestinoTransferenciaCellcoin"
                (click)="selecioneNovaChaveTransferenciaPixCellcoin()">
          <span>
            <small>Transferir para nova chave Pix</small>
            <strong>
              <em>{{novaChaveIdentificadaTransferenciaCellcoin.rotulo}}</em>
              {{formateNovaChavePixCellcoin(novaChaveIdentificadaTransferenciaCellcoin.chave, novaChaveIdentificadaTransferenciaCellcoin.tipo)}}
            </strong>
          </span>
          <span class="spinner-border spinner-border-sm"
                *ngIf="consultandoDestinoTransferenciaCellcoin"></span>
          <i class="fas fa-arrow-right" *ngIf="!consultandoDestinoTransferenciaCellcoin"></i>
        </button>

        <div class="cellcoin-bank-transfer-new-key-error" *ngIf="erroNovaChaveTransferenciaCellcoin">
          <i class="fas fa-exclamation-circle"></i>
          <span>{{erroNovaChaveTransferenciaCellcoin}}</span>
        </div>
      </div>
    </section>

    <section class="cellcoin-bank-transfer-stage" *ngIf="etapaTransferenciaCellcoin === 'valor'">
      <div class="cellcoin-bank-transfer-recipient">
        <span class="cellcoin-bank-transfer-avatar">
          {{iniciaisPessoaCellcoin(destinoTransferenciaCellcoin?.destinatario?.nome)}}
        </span>
        <div>
          <small>Você vai transferir para</small>
          <strong>{{destinoTransferenciaCellcoin?.destinatario?.nome}}</strong>
          <span>{{destinoTransferenciaCellcoin?.destinatario?.tipoChave}} · {{destinoTransferenciaCellcoin?.destinatario?.chave}}</span>
        </div>
      </div>
      <h3>Quanto vai transferir para {{destinoTransferenciaCellcoin?.destinatario?.nome}}?</h3>
      <div class="cellcoin-bank-transfer-balance">
        <div>
          <span>Disponível para transferir</span>
          <small *ngIf="destinoTransferenciaCellcoin?.saldoReservado > 0">
            {{formateMoedaCellcoin(destinoTransferenciaCellcoin?.saldoReservado)}} aguardando confirmação
          </small>
        </div>
        <strong>{{formateMoedaCellcoin(destinoTransferenciaCellcoin?.saldoDisponivel)}}</strong>
      </div>
      <label class="cellcoin-bank-transfer-value">
        <span>Valor da transferência</span>
        <div><b>R$</b>
          <input type="number"
                 min="0.01"
                 step="0.01"
                 [max]="destinoTransferenciaCellcoin?.saldoDisponivel"
                 [(ngModel)]="valorTransferenciaCellcoin"
                 [disabled]="preparandoTransferenciaCellcoin"
                 placeholder="0,00">
        </div>
      </label>
    </section>

    <section class="cellcoin-bank-transfer-stage" *ngIf="etapaTransferenciaCellcoin === 'resumo'">
      <div class="cellcoin-bank-transfer-stage-icon"><i class="fas fa-paper-plane"></i></div>
      <span class="cellcoin-bank-transfer-overline">Revise os dados</span>
      <h3>Transferir {{formateMoedaCellcoin(transferenciaPreparadaCellcoin?.valor)}} para {{transferenciaPreparadaCellcoin?.destinatario?.nome}}?</h3>
      <div class="cellcoin-bank-transfer-summary">
        <div><span>Valor</span><strong>{{formateMoedaCellcoin(transferenciaPreparadaCellcoin?.valor)}}</strong></div>
        <div><span>Tipo</span><strong>Pix</strong></div>
        <div><span>CPF/CNPJ</span><strong>{{transferenciaPreparadaCellcoin?.destinatario?.chave}}</strong></div>
        <div><span>Instituição</span><strong>{{destinoTransferenciaCellcoin?.destinatario?.instituicao || destinoTransferenciaCellcoin?.destinatario?.ispb || '-'}}</strong></div>
      </div>
      <div class="cellcoin-transfer-confirmation-warning">
        <i class="fas fa-shield-alt"></i>
        <div>
          <strong>Autorização confirmada por e-mail</strong>

        </div>
      </div>
    </section>

    <section class="cellcoin-bank-transfer-result cellcoin-bank-transfer-processing"
             *ngIf="etapaTransferenciaCellcoin === 'processando'">
      <div class="cellcoin-bank-transfer-processing-icon">
        <span></span>
        <i class="fas fa-paper-plane"></i>
      </div>
      <span class="cellcoin-bank-transfer-overline">
        {{confirmandoTransferenciaCellcoin ? 'Enviando transferência' : 'Aguardando confirmação'}}
      </span>
      <h3>
        {{confirmandoTransferenciaCellcoin ? 'Estamos enviando seu Pix' : 'Seu Pix está sendo processado'}}
      </h3>
      <p>
        Aguarde a confirmação da Cellcoin. Esta tela será atualizada automaticamente quando recebermos o webhook.
      </p>
      <div class="cellcoin-bank-transfer-result-value">
        <small>Valor enviado</small>
        <strong>{{formateMoedaCellcoin(transferenciaPreparadaCellcoin?.valor)}}</strong>
        <span>para {{transferenciaPreparadaCellcoin?.destinatario?.nome}}</span>
      </div>
      <div class="cellcoin-bank-transfer-waiting-status">
        <span class="spinner-border spinner-border-sm"></span>
        {{confirmandoTransferenciaCellcoin ? 'Enviando à Cellcoin' : rotuloStatusTransferenciaCellcoin(transferenciaPreparadaCellcoin?.status || 'PROCESSING')}}
      </div>
      <small class="cellcoin-bank-transfer-result-note">
        Você pode fechar esta janela. O processamento continuará e ficará disponível no histórico.
      </small>
      <div class="cellcoin-bank-transfer-poll-error" *ngIf="erroAcompanhamentoTransferenciaCellcoin">
        <i class="fas fa-wifi"></i>
        Não conseguimos atualizar agora. Tentaremos novamente automaticamente.
      </div>
    </section>

    <section class="cellcoin-bank-transfer-result cellcoin-bank-transfer-success"
             *ngIf="etapaTransferenciaCellcoin === 'concluido'">
      <div class="cellcoin-bank-transfer-result-icon"><i class="fas fa-check"></i></div>
      <span class="cellcoin-bank-transfer-overline">Transferência concluída</span>
      <h3>Pix enviado com sucesso!</h3>
      <p>A Cellcoin confirmou a transferência.</p>
      <div class="cellcoin-bank-transfer-result-value">
        <small>Valor transferido</small>
        <strong>{{formateMoedaCellcoin(transferenciaPreparadaCellcoin?.valor)}}</strong>
        <span>para {{transferenciaPreparadaCellcoin?.destinatario?.nome}}</span>
      </div>
      <div class="cellcoin-bank-transfer-result-details">
        <div><span>Chave Pix</span><strong>{{transferenciaPreparadaCellcoin?.destinatario?.chave}}</strong></div>
        <div><span>Identificador</span><strong>{{transferenciaPreparadaCellcoin?.transactionId || transferenciaPreparadaCellcoin?.endToEndId}}</strong></div>
      </div>
    </section>

    <section class="cellcoin-bank-transfer-result cellcoin-bank-transfer-failure"
             *ngIf="etapaTransferenciaCellcoin === 'falha'">
      <div class="cellcoin-bank-transfer-result-icon"><i class="fas fa-times"></i></div>
      <span class="cellcoin-bank-transfer-overline">Transferência não concluída</span>
      <h3>Não foi possível concluir o Pix</h3>
      <p>{{erroFluxoTransferenciaCellcoin || 'A Cellcoin não confirmou a transferência.'}}</p>
      <div class="cellcoin-bank-transfer-result-value">
        <small>Valor</small>
        <strong>{{formateMoedaCellcoin(transferenciaPreparadaCellcoin?.valor)}}</strong>
        <span>{{transferenciaPreparadaCellcoin?.destinatario?.nome}}</span>
      </div>
    </section>

    <section class="cellcoin-bank-transfer-result cellcoin-bank-transfer-returned"
             *ngIf="etapaTransferenciaCellcoin === 'devolvido'">
      <div class="cellcoin-bank-transfer-result-icon"><i class="fas fa-undo-alt"></i></div>
      <span class="cellcoin-bank-transfer-overline">Pix devolvido</span>
      <h3>O valor foi devolvido para sua conta</h3>
      <p>A transferência foi concluída, mas posteriormente devolvida pela instituição recebedora.</p>
      <div class="cellcoin-bank-transfer-result-value">
        <small>Valor devolvido</small>
        <strong>{{formateMoedaCellcoin(transferenciaPreparadaCellcoin?.valor)}}</strong>
      </div>
    </section>
  </div>

  <kendo-dialog-actions *ngIf="etapaTransferenciaCellcoin === 'codigo'">
    <button kendoButton (click)="fecheConfirmacaoTransferenciaCellcoin()">Cancelar</button>
    <button kendoButton themeColor="primary"
            class="cellcoin-bank-transfer-primary-action"
            [disabled]="codigoTransferenciaCellcoin.length !== 6 || solicitandoCodigoTransferenciaCellcoin || validandoCodigoTransferenciaCellcoin"
            (click)="valideCodigoTransferenciaPixCellcoin()">
      <span class="spinner-border spinner-border-sm mr-1" *ngIf="validandoCodigoTransferenciaCellcoin"></span>
      Validar código
    </button>
  </kendo-dialog-actions>
  <kendo-dialog-actions *ngIf="etapaTransferenciaCellcoin === 'chaves'">
    <button kendoButton [disabled]="consultandoDestinoTransferenciaCellcoin"
            (click)="fecheConfirmacaoTransferenciaCellcoin()">Cancelar</button>
  </kendo-dialog-actions>
  <kendo-dialog-actions *ngIf="etapaTransferenciaCellcoin === 'valor'">
    <button kendoButton [disabled]="preparandoTransferenciaCellcoin"
            (click)="volteEtapaTransferenciaPixCellcoin()">Voltar</button>
    <button kendoButton themeColor="primary"
            class="cellcoin-bank-transfer-primary-action"
            [disabled]="preparandoTransferenciaCellcoin || !valorTransferenciaCellcoin"
            (click)="prepareTransferenciaPixCellcoin()">
      <span class="spinner-border spinner-border-sm mr-1" *ngIf="preparandoTransferenciaCellcoin"></span>
      Continuar
    </button>
  </kendo-dialog-actions>
  <kendo-dialog-actions *ngIf="etapaTransferenciaCellcoin === 'resumo'">
    <button kendoButton [disabled]="confirmandoTransferenciaCellcoin"
            (click)="fecheConfirmacaoTransferenciaCellcoin()">Cancelar</button>
    <button kendoButton themeColor="primary"
            class="cellcoin-bank-transfer-primary-action"
            [disabled]="confirmandoTransferenciaCellcoin"
            (click)="confirmeTransferenciaPixCellcoin()">
      <span class="spinner-border spinner-border-sm mr-1" *ngIf="confirmandoTransferenciaCellcoin"></span>
      Confirmar transferência
    </button>
  </kendo-dialog-actions>
  <kendo-dialog-actions *ngIf="etapaTransferenciaCellcoin === 'expirado'">
    <button kendoButton (click)="fecheConfirmacaoTransferenciaCellcoin()">Cancelar</button>
    <button kendoButton themeColor="primary"
            class="cellcoin-bank-transfer-primary-action"
            [disabled]="confirmandoTransferenciaCellcoin"
            (click)="inicieNovamenteTransferenciaPixCellcoin()">
      Iniciar novamente
    </button>
  </kendo-dialog-actions>
  <kendo-dialog-actions *ngIf="etapaAcompanhamentoTransferenciaPixCellcoin()">
    <button kendoButton
            class="cellcoin-bank-transfer-close-result"
            (click)="fecheConfirmacaoTransferenciaCellcoin()">
      Fechar
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="modalWebhooksContaCellcoin"
              class="cellcoin-webhook-replay-dialog"
              title="Webhooks enviados pela Cellcoin"
              (close)="fecheWebhooksContaCellcoin()"
              [minWidth]="320"
              [width]="1040">
  <div class="cellcoin-webhook-replay-modal">
    <div class="cellcoin-webhook-replay-toolbar">
      <label>
        <span>Tipo de webhook</span>
        <select class="k-textbox"
                name="webhookContaSelecionado"
                [(ngModel)]="webhookContaSelecionado"
                [disabled]="carregandoOpcoesWebhooksContaCellcoin || carregandoWebhooksContaCellcoin || !!reenviandoWebhookContaCellcoin"
                (ngModelChange)="selecionouWebhookContaCellcoin()">
          <option *ngFor="let opcao of opcoesWebhooksContaCellcoin" [value]="opcao.key">
            {{opcao.label}} · {{opcao.entity}}
          </option>
        </select>
      </label>
      <button type="button"
              class="cellcoin-account-btn cellcoin-account-btn-ghost"
              [disabled]="carregandoWebhooksContaCellcoin || !webhookContaSelecionado || !!reenviandoWebhookContaCellcoin"
              (click)="carregueWebhooksContaCellcoin()">
        <span class="spinner-border spinner-border-sm" *ngIf="carregandoWebhooksContaCellcoin"></span>
        <i class="fas fa-sync-alt" *ngIf="!carregandoWebhooksContaCellcoin"></i>
        Atualizar
      </button>
    </div>

    <div class="cellcoin-webhook-replay-period" *ngIf="replayWebhooksContaCellcoin">
      <span>{{replayWebhooksContaCellcoin.webhook?.product}}</span>
      <span>{{replayWebhooksContaCellcoin.dateFrom | date:'dd/MM/yyyy HH:mm'}} até {{replayWebhooksContaCellcoin.dateTo | date:'dd/MM/yyyy HH:mm'}}</span>
      <span>{{replayWebhooksContaCellcoin.quantidadeDias}} dia(s)</span>
      <strong>{{replayWebhooksContaCellcoin.totalItems || 0}} envio(s)</strong>
    </div>

    <div class="alert alert-danger" *ngIf="erroWebhooksContaCellcoin">{{erroWebhooksContaCellcoin}}</div>
    <div class="alert alert-success" *ngIf="mensagemWebhooksContaCellcoin">{{mensagemWebhooksContaCellcoin}}</div>

    <div class="cellcoin-statement-loading"
         *ngIf="carregandoOpcoesWebhooksContaCellcoin || carregandoWebhooksContaCellcoin">
      <span class="spinner-border spinner-border-sm"></span>
      Consultando webhooks enviados no período permitido pela Cellcoin...
    </div>

    <div class="cellcoin-statement-empty"
         *ngIf="!carregandoOpcoesWebhooksContaCellcoin && !carregandoWebhooksContaCellcoin &&
                 replayWebhooksContaCellcoin && !webhooksEnviadosContaCellcoin().length && !erroWebhooksContaCellcoin">
      <i class="far fa-folder-open"></i>
      <strong>Nenhum webhook encontrado</strong>
      <span>A Cellcoin não retornou envios dessa entidade no período consultado.</span>
    </div>

    <div class="cellcoin-webhook-replay-list"
         *ngIf="!carregandoWebhooksContaCellcoin && webhooksEnviadosContaCellcoin().length">
      <article class="cellcoin-webhook-replay-item"
               *ngFor="let webhook of webhooksEnviadosContaCellcoin()"
               [ngClass]="classeReplayWebhookContaCellcoin(webhook)">
        <header>
          <div>
            <strong>{{webhook.status || 'Status não informado'}}</strong>
            <span class="cellcoin-statement-reference">{{webhook.webhookId}}</span>
          </div>
          <div class="cellcoin-webhook-replay-meta">
            <span *ngIf="webhook.httpStatusCode">HTTP {{webhook.httpStatusCode}}</span>
            <span *ngIf="webhook.createDate">{{webhook.createDate | date:'dd/MM/yyyy HH:mm:ss'}}</span>
            <button type="button"
                    class="cellcoin-account-btn cellcoin-account-btn-ghost"
                    [disabled]="!!reenviandoWebhookContaCellcoin"
                    (click)="reenvieWebhookContaCellcoin(webhook)">
              <span class="spinner-border spinner-border-sm"
                    *ngIf="reenviandoWebhookContaCellcoin === webhook.webhookId"></span>
              <i class="fas fa-redo"
                 *ngIf="reenviandoWebhookContaCellcoin !== webhook.webhookId"></i>
              Reenviar
            </button>
          </div>
        </header>

        <div class="cellcoin-webhook-replay-url" *ngIf="webhook.webhookUrl">{{webhook.webhookUrl}}</div>

        <div class="cellcoin-webhook-replay-payloads">
          <details>
            <summary>Request enviado</summary>
            <pre>{{formateJsonWebhookContaCellcoin(webhook.request)}}</pre>
          </details>
          <details>
            <summary>Resposta recebida</summary>
            <pre>{{formateJsonWebhookContaCellcoin(webhook.response)}}</pre>
          </details>
        </div>
      </article>
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton
            [disabled]="!!reenviandoWebhookContaCellcoin"
            (click)="fecheWebhooksContaCellcoin()">
      Fechar
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
